import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-notifications-popup',
  templateUrl: './notifications-popup.component.html',
  styleUrls: ['./notifications-popup.component.css']
})
export class NotificationsPopupComponent implements OnInit {
  @Input() notificationsPopUp: any = {};
  @Input() currentLevel: any = '';
  @Output() onClosePopup = new EventEmitter();
  userProfileImage;
  popTitle = '';
  popMsg = '';

  constructor(
    public translate: TranslateService,
  ) { }

  ngOnInit(): void {
    switch(this.notificationsPopUp.category){
      case 'Bid Accepted':
        this.popTitle = this.translate.instant('notifications.bid_accepted_popup_title');
        this.popMsg = this.translate.instant('notifications.bid_accepted_popup_text');
        break;
      case 'Sale Settele For Seller':
        this.popTitle = this.translate.instant('notifications.sale_settle_popup_title').replace("$1", this.notificationsPopUp.wineName);
        this.popMsg = this.translate.instant('notifications.sale_settle_popup_text');
        break;  
    }
  }

  closePopup(): void {
    this.onClosePopup.emit();
  }
}
